<template>
  <SubLayout
      :pageTitle="title"
      :pageBreadcrumbs="breadcrumbs"
      :hasBack="true"
      :loading="false"
  >
    <template #layoutContent>
      <Loader :isLoading="isLoading">
        <Card container-class="card mb-9">
          <div class="card-body pt-9 pb-0">
            <EventTopHeader :event="event" @invitation="showEvent"/>
            <ul class="nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bold">
              <li class="nav-item mt-2" @click="toggleTab('tab-information')" v-if="$can(abilities.CAN_VIEW_EVENT)">
                <a class="nav-link text-active-primary ms-0 me-10 py-5" :class="{'active' : (route.query.tab === 'tab-information' || !route.query.tab) }"  data-bs-toggle="tab" href="#tab-information">
                  {{ $t('events.information') }}
                </a>
              </li>
              <li class="nav-item mt-2" @click="toggleTab('tab-planning')">
                <a class="nav-link text-active-primary ms-0 me-10 py-5" :class="{'active' : route.query.tab === 'tab-planning' }"  data-bs-toggle="tab" href="#tab-planning">
                  {{$t("events.planning.title")}}
                </a>
              </li>
              <li class="nav-item mt-2" @click="toggleTab('tab-subscriptions')" v-if="$can(abilities.CAN_VIEW_EVENT_SUBSCRIPTOR) || $can(abilities.CAN_VIEW_EVENT_ALL_SUBSCRIPTOR)">
                <a class="nav-link text-active-primary ms-0 me-10 py-5" :class="{'active' : isSubTabActive }"  data-bs-toggle="tab" href="#tab-subscriptions">
                  {{ $t('events.inscriptions') }}
                </a>
              </li>
              <li class="nav-item mt-2" @click="toggleTab('tab-badges')">
                <a class="nav-link text-active-primary ms-0 me-10 py-5" :class="{'active' : isStandTabActive }" data-bs-toggle="tab" href="#tab-badges">
                  {{ $t('events.badges_stands') }}
                </a>
              </li>
              <li class="nav-item mt-2" @click="toggleTab('tab-nps')">
                <a class="nav-link text-active-primary ms-0 me-10 py-5" :class="{'active' : route.query.tab === 'tab-nps' }"  data-bs-toggle="tab" href="#tab-nps">
                  {{$t("events.nps.nps")}}
                </a>
              </li>
              <li class="nav-item mt-2" @click="toggleTab('tab-presences')">
                <a class="nav-link text-active-primary ms-0 me-10 py-5" :class="{'active' : route.query.tab === 'tab-presences' }"  data-bs-toggle="tab" href="#tab-presences">
                  {{$t("events.presences.stats")}}
                </a>
              </li>
              <li v-if="false" class="nav-item mt-2" @click="toggleTab('tab-emails')">
                <a class="nav-link text-active-primary ms-0 me-10 py-5" :class="{'active' : route.query.tab === 'tab-emails' }"  data-bs-toggle="tab" href="#tab-emails">
                  {{$t("events.emails")}}
                </a>
              </li>
            </ul>
          </div>
        </Card>

        <div class="tab-content" id="myTabContent">
          <div class="tab-pane fade show " :class="{'active' : route.query.tab === 'tab-information' || !route.query.tab }" id="tab-information" v-if="$can(abilities.CAN_VIEW_EVENT)" role="tabpanel">
            <InformationComponent :detail="eventData" @load="loadData"/>
          </div>
          <div class="tab-pane fade show " :class="{'active' : route.query.tab === 'tab-planning' }" id="tab-planning" role="tabpanel">
            <Planning/>
          </div>
          <div class="tab-pane fade show " :class="{'active' : isSubTabActive }" v-if="$can(abilities.CAN_VIEW_EVENT_SUBSCRIPTOR) || $can(abilities.CAN_VIEW_EVENT_ALL_SUBSCRIPTOR)" id="tab-subscriptions" role="tabpanel">
            <SubscriptionTab @reload="reloadParticipators" :detail="eventData" />
          </div>
          <div class="tab-pane fade show " :class="{'active' : isStandTabActive }" id="tab-badges" role="tabpanel">
            <Stands/>
          </div>
          <div class="tab-pane fade show " :class="{'active' : route.query.tab === 'tab-nps' }" id="tab-nps" role="tabpanel">
            <router-view></router-view>
          </div>
          <div class="tab-pane fade show " :class="{'active' : route.query.tab === 'tab-presences' }" id="tab-presences" role="tabpanel">
            <StatisticTab/>
          </div>
          <div v-if="false" class="tab-pane fade show " :class="{'active' : route.query.tab === 'tab-emails' }" id="tab-emails" role="tabpanel">
            <EmailTab />
          </div>
        </div>
      </Loader>
    </template>
  </SubLayout>
</template>

<script setup>

import {useStore} from "vuex";
import {useRoute, useRouter} from "vue-router";
import {computed, onMounted, ref , watch} from "vue";
import Loader from "@/components/Loader.vue";
import SubLayout from "@/views/Layouts/partials/SubLayout.vue";
import Card from "@/Modules/Financial/components/Card.vue";
import EventTopHeader from "@/Modules/Events/components/EventTopHeader.vue";
import SubscriptionTab from "@/Modules/Events/views/events/components/SubscriptionTab.vue";
import InformationComponent from "./components/InformationComponent.vue";
import { useClipboard } from "@/composables/useClipboard";
import abilities from "@/composables/abilities";
import Planning from "../Planning/Index.vue"
import Stands from "../Stands/Index.vue"
import StatisticTab from "./components/StatisticTab"
import EmailTab from "@/Modules/Events/views/events/components/EmailTab.vue";

const store = useStore()
const router = useRouter()
const route = useRoute()

const  {initCopyToClipboard} = useClipboard()

const title = ref( "events.title")
const breadcrumbs = ref([
  {
    name: 'events.list',
    route: 'events-index'
  },
  {
    name: 'events.detail',
    route: 'events-view',
    params: route.params.id
  }
])
const isLoading = ref(true)
const participatorTab = ref()
const invitation = ref(false)

const event = computed(() => store.getters['events/getCurrentEvent'])
const isSubTabActive = computed(() => ['tab-subscriptions', 'tab-invitations', 'tab-questions'].includes(route.query.tab))
const isStandTabActive = computed(() => ['tab-badges', 'tab-stands', 'tab-participators'].includes(route.query.tab))
const eventData = ref({})


watch(() => event.value, (value) => {
  if(value.id) {
    let data = value;
    let days = [];
    let logoSplit = data?.logo?.split('/')
    let logoName = logoSplit[logoSplit?.length - 1]

    data?.dates?.forEach((item, index) => {
      days.push({
        id: index+1,
        hour_id: item.id,
        date: moment(item.day).format('DD-MM-YYYY'),
        startHour: moment(item.start, 'HH:mm:ss').format('HH:mm'),
        endHour: moment(item.end, 'HH:mm:ss').format('HH:mm')
      })
    });

    const sortedDates = days.sort((a, b) => {
      const d1 = new Date(a.date.split('-').reverse().join('-'));
      const d2 = new Date(b.date.split('-').reverse().join('-'));
      return d1 - d2;
    });


    eventData.value = {
      id: data?.id,
      title: data?.title,
      description: data?.description,
      latitude: data?.latitude,
      longitude: data?.longitude,
      place: data?.place,
      logo: null,
      logo_url: data?.logo,
      logo_name: logoName,
      timezone_id: data?.timezone_id,
      days: sortedDates,
      number_of_places: data?.number_of_places,
      is_free: data?.is_free,
      remove: []
    }

  }

}, { deep: true })

function toggleTab(tabId){
  if(tabId === 'tab-nps'){
    router.push({ name: 'events-nps-index', params: { id: route.params.id }, query: { tab: tabId } });
  }else{
    router.replace({ query: { ...route.query, tab: tabId } });
  }
}

function reloadParticipators() {
  if(participatorTab.value) {
    participatorTab.value.reloadParticipatorData()
  }
}

const loadData = () => {
  store.dispatch('events/getEventDetail', route.params.id)
      .finally(() => isLoading.value = false)
}

onMounted(() => {
  initCopyToClipboard()
  useClipboard({ buttonSelector: 'mini-link-cpy' }).initCopyToClipboard();
  loadData()
})

</script>

<style scoped>

</style>